import { useTypedSelector } from 'hooks';

/**
 * Whether the tenant config this screen reads its currency, industry and industry-scoped cards from
 * has yet to arrive.
 *
 * NOT `global.loading`: `USER_EXTEND_SESSION` raises that flag (`containers/App/reducer.ts`) and
 * `IdleHandler` dispatches it on a token-TTL interval from the app shell, so it goes true again on
 * every token refresh — which would blank every amount, drop the industry line and put resolved
 * cards back into the load state that renders a title and tooltip for a card the role may not hold.
 *
 * `tenantConfig.id` is the resolution signal instead: the reducer's initial config is a populated
 * default whose `id` is null, only `GET_NECESSITIES_SUCCESS` replaces it with the fetched tenant,
 * and no action clears it afterwards. PLA-8815.
 */
export const useTenantConfigPending = (): boolean =>
  useTypedSelector(state => !state.global?.tenantConfig?.id);

export default useTenantConfigPending;
